'use strict';

export default ($filter, currencySymbol) => {
  'ngInject';

  return (priceInfo, boldText, allowFree = true) => {
    priceInfo = priceInfo || {};

    const price = priceInfo.fullPrice || 0;
    var currenciesWithCode = ['AUD', 'CAD', 'HKD', 'MXN', 'NZD', 'SGD', 'SEK', 'NOK', 'DKK'];
    let curencyCode;

    if(currenciesWithCode.indexOf(priceInfo.currency) > -1){
      curencyCode = `<sup>${priceInfo.currency}<sup>`;
    }else {
      curencyCode = '';
    }

    if (price || !allowFree) {

      const symbol = currencySymbol(priceInfo.currency);
      return `<strong><sup>${symbol}</sup>${price}${curencyCode}</strong>/h`;
    } else {
      const tag = boldText ? 'strong' : 'span';
      return `<${tag}>Free</${tag}>`;
    }
  };
};



// WEBPACK FOOTER //
// ./app/src/filters/guide_price.filter.js